import Moment from "react-moment";
import formatMoney from "../../../../utils/formatMoney";

export default function DocumentLine({ item }: any) {
  return (
    <div className="grid grid-cols-12 border-t border-black items-center text-gray-700">
      <div className="col-span-2 p-2 border-r border-black  text-left">
        <Moment format="Do MMM, YYYY">{(item?.invoice_date).toString()}</Moment>
      </div>
      <div className="col-span-2 p-2 border-r border-black  text-center">
        {item?.invoice_number}
      </div>
      <div className="col-span-2 p-2  border-r border-black truncate">
        {item.reference}
      </div>
      <div className="col-span-2 p-2 border-r border-black  text-right">
        {formatMoney(item?.total_amount)}
      </div>
      <div className="col-span-2 p-2 border-r border-black  text-right">
        {formatMoney(item?.total_amount - item?.outstanding)}
      </div>
      <div className="col-span-2 p-2 text-right">
        {formatMoney(item?.outstanding)}
      </div>
    </div>
  );
}
